import { render } from "./AttendanceSummaryReport.vue?vue&type=template&id=683beb10&scoped=true"
import script from "./AttendanceSummaryReport.vue?vue&type=script&lang=js"
export * from "./AttendanceSummaryReport.vue?vue&type=script&lang=js"

import "../../core/components/table/reports-table.scss?vue&type=style&index=0&id=683beb10&lang=scss&scoped=true"

import exportComponent from "/opt/karibu-hrms/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-683beb10"]])

export default __exports__